module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result_container"
  }, [_c('div', {
    staticClass: "operation_box"
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-duigou research-font-color",
    staticStyle: {
      "font-size": "60px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "main",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.displayResult))]), _vm._v(" "), _c('span', {
    staticClass: "submain",
    attrs: {
      "lines": 1
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "return-button research-background-color",
    on: {
      "click": _vm.goHome
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("返回主页")])]), _vm._v(" "), (_vm.ifShowLottery && _vm.lotteryUrl) ? _c('a', {
    attrs: {
      "href": _vm.lotteryUrl
    }
  }, [_c('img', {
    staticClass: "lottery-image",
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/首单抽奖.png"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.ifShowInstruction) ? _c('div', {
    staticClass: "modal-overlay modal-overlay-visible"
  }, [_c('div', {
    staticClass: "lottery-background"
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "105px",
      "top": "400px",
      "left": "50px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/coupon-self.png"
    },
    on: {
      "click": _vm.getCouponForSelf
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "105px",
      "top": "400px",
      "right": "50px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/coupon-gift.png"
    },
    on: {
      "click": _vm.getCouponForFriend
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "28px",
      "left": "260px",
      "top": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/promotion/lottery-close.png"
    },
    on: {
      "click": function($event) {
        _vm.ifShowInstruction = false
      }
    }
  }), _vm._v(" "), (_vm.promotions618Used && _vm.promotions618Used.length > 0) ? _c('div', {
    staticClass: "lottery-discount"
  }, [_vm._l((_vm.promotions618Used), function(pro) {
    return _c('div', [(_vm.promotions618Used.length === 1) ? _c('div', {
      staticStyle: {
        "line-height": "10px",
        "opacity": "0"
      }
    }, [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (pro.categoryId === 20) ? _c('div', [_vm._v("定制产品"), _c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(pro.discount))]), _vm._v("折")]) : _c('div', [_vm._v("现货及质粒产品"), _c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(pro.discount))]), _vm._v("折")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "transform": "scale(0.8)",
      "color": "#424242"
    }
  }, [_vm._v("使用截止日期2020.7.18")])], 2) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a8bb66a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/SuccessPay.vue
// module id = 1646
// module chunks = 8